import * as React from 'react';
import PropTypes from 'prop-types';

import LanguageConverterV2 from '@careerstart/wae-common/src/main/helperFunction/LanguageConverterV2';
import { Box, Button, List, ListItem, ListItemText, Modal, Typography } from '@mui/material';

import { BUTTON_STYLES } from '../../../../../theme/buttonStyles';
import { BLACK } from '../../../../../theme/colorConstants';
import { PRIMARY_FONT } from '../../../../../theme/fontConstants';

const ImpactedPositionsDisplayModal = ({ open, onClose, positionTemplates }) => (
  <Modal
    open={open}
    onClose={onClose}
    aria-labelledby="positions-impacted-modal"
    aria-describedby="positions-impacted-description"
  >
    <Box
      sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: { xs: '90%', sm: '500px' },
        maxHeight: '80vh',
        bgcolor: 'background.paper',
        borderRadius: '12px',
        boxShadow: 24,
        p: 4,
        display: 'flex',
        flexDirection: 'column',
        gap: 4,
      }}
    >
      {/* Modal Header */}
      <Box
        sx={{
          borderBottom: `1px solid ${BLACK[20]}`,
        }}
      >
        <Typography
          id="positions-impacted-modal"
          sx={{
            fontSize: '20px',
            fontFamily: PRIMARY_FONT[700],
            color: BLACK[100],
            lineHeight: '24px',
          }}
        >
          {LanguageConverterV2('contractCard.positionsImpactedTitle')}
        </Typography>
        <Typography
          id="positions-impacted-description"
          sx={{
            fontSize: '14px',
            fontFamily: PRIMARY_FONT[400],
            color: BLACK[80],
            lineHeight: '20px',
          }}
        >
          {LanguageConverterV2('contractCard.positionsImpactedSubtitle')}
        </Typography>
      </Box>

      {/* Modal Content - Scrollable */}
      <Box
        sx={{
          border: `1px solid ${BLACK[90]}`,
          borderRadius: '12px',
        }}
      >
        <Box
          sx={{
            flex: 1,
            overflow: 'auto',
            maxHeight: '45vh',
            p: 0,
          }}
        >
          {positionTemplates?.length > 0 ? (
            <List sx={{ p: 3 }}>
              {positionTemplates.map((position, index) => (
                <ListItem
                  key={position.id || index}
                  sx={{
                    borderBottom:
                      index < positionTemplates.length - 1 ? `1px solid ${BLACK[10]}` : 'none',
                    py: 0,
                    px: 1,
                  }}
                >
                  <ListItemText
                    primary={position.name || LanguageConverterV2('contractCard.unnamedPosition')}
                    sx={{
                      '& .MuiListItemText-primary': {
                        fontSize: '16px',
                        fontFamily: PRIMARY_FONT[400],
                        color: BLACK[100],
                      },
                    }}
                  />
                </ListItem>
              ))}
            </List>
          ) : (
            <Box
              sx={{
                textAlign: 'center',
              }}
            >
              <Typography
                sx={{
                  fontSize: '16px',
                  fontFamily: PRIMARY_FONT[400],
                  color: BLACK[60],
                  fontStyle: 'italic',
                }}
              >
                {LanguageConverterV2('contractCard.noPositionsFound')}
              </Typography>
            </Box>
          )}
        </Box>
      </Box>

      {/* Modal Footer */}
      <Box
        sx={{
          borderTop: `1px solid ${BLACK[20]}`,
          display: 'flex',
          justifyContent: 'flex-end',
        }}
      >
        <Button onClick={onClose} variant="outlined" sx={BUTTON_STYLES.primarySmall}>
          {LanguageConverterV2('button.close')}
        </Button>
      </Box>
    </Box>
  </Modal>
);

ImpactedPositionsDisplayModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  positionTemplates: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
    })
  ),
};

export default ImpactedPositionsDisplayModal;
